export default __webpack_public_path__ + "static/media/EM1410.34I-36631_-21609_0.078f0572.jpg";